import React from 'react';
import { concatStyles } from 'utils';
var SECTION_STYLES = 'py-3 flex flex-col';
export var Section = function (_a) {
    var children = _a.children, className = _a.className;
    return (React.createElement("section", { className: concatStyles(SECTION_STYLES, className) }, children));
};
